/**
 * Xes appid map
 */
export var map = {
  'biglive.xueersi.com': {
    appid: '1000002',
    appkey: 'f515ff7716c58232ab5375910341dda2'
  },
  'oa.xueersi.com': {
    appid: '1000003',
    appkey: '337511d35ae53a51ab07248ae107fcee'
  },
  'xescrm.xueersi.com': {
    appid: '1000004',
    appkey: '72ab1202acaa377f0129bcc65552918d'
  },
  'crm.xueersi.com': {
    appid: '1000005',
    appkey: '56ab146f8dc2847cd73582c1392aa82b'
  },
  'laoshi.xueersi.com': {
    appid: '1000006',
    appkey: '06a6076434a86e39de41148fc62f11fa'
  },
  'api.xueersi.com': {
    appid: '1000007',
    appkey: 'd47d3c34ff1edcc675364a2f9b1974f5'
  },
  'api.beta.xueersi.com': {
    appid: '1000008',
    appkey: 'b520f24d97186bddcb218b07c4cd7c98'
  },
  'login.xueersi.com': {
    appid: '1000009',
    appkey: '3ff2887396046fab92facf84017b8229'
  },
  'cart.xueersi.com': {
    appid: '1000010',
    appkey: '35028e31f35ae1c8629f778b36dc9c20'
  },
  'i.xueersi.com': {
    appid: '1000011',
    appkey: 'e634b05b654a6b0d0da7e918611b5605'
  },
  'www.xueersi.com': {
    appid: '1000012',
    appkey: '651549f8600025626961a0eb91dcd860'
  },
  'xueersi.com': {
    appid: '1000012',
    appkey: '651549f8600025626961a0eb91dcd860'
  },
  'account.xueersi.com': {
    appid: '1000014',
    appkey: '0fa13c38d019d225c4990399cabe275a'
  },
  'teacher.xueersi.com': {
    appid: '1000015',
    appkey: '67e59dbfa827bc184c3778336c75e1f9'
  },
  'admin.xueersi.com': {
    appid: '1000016',
    appkey: 'b33b76c79995dba48ac64ee9f97fa98c'
  },
  'chat.xueersi.com': {
    appid: '1000017',
    appkey: '02db98680b2842aec052d85dd01998b4'
  },
  'exam.xueersi.com': {
    appid: '1000018',
    appkey: 'a1cbd0bb65259f5a1913d2f3fdbc48f3'
  },
  'fcenter.xueersi.com': {
    appid: '1000019',
    appkey: 'ed373ed7aface7d0fd37da3b18facc97'
  },
  'huodong.xueersi.com': {
    appid: '1000020',
    appkey: 'f295f68a6086ef96846f9fbab4119e8a'
  },
  'searchapi.xueersi.com': {
    appid: '1000021',
    appkey: 'b7fdf30f0449a6c3f5ec7eb8482a1abb'
  },
  'touch.xueersi.com': {
    appid: '1000022',
    appkey: 'c33a49e00a39a5030345dc69fc1f58d2'
  },
  'weixin.xueersi.com': {
    appid: '1000023',
    appkey: 'cc14f378aa55ec9f6d5aa7198dc3f221'
  },
  'reg.xueersi.com': {
    appid: '1000024',
    appkey: '4f761b3c086e5176bcab7eed69ade17a'
  },
  'student.xueersi.com': {
    appid: '1000025',
    appkey: '0c653ab2516c321fb88c0ad5151f21e9'
  },
  'bigclass.xueersi.com': {
    appid: '1000026',
    appkey: 'fe4bf03206c986691260cd1b327ad105'
  },
  'asr.xueersi.com': {
    appid: '1000027',
    appkey: '7defe6551ac775ebc6b68ba2ed75b5f5'
  },
  'club.xueersi.com': {
    appid: '1000028',
    appkey: '699abfe629c079cee9a9cb0bd7934c0f'
  },
  'zt.xueersi.com': {
    appid: '1000038',
    appkey: 'f6b5194981066e3949f7b0af8f9e5bb1'
  },
  'icourse.xesimg.com': {
    appid: '1001230',
    appkey: '6588c032ce5e6e4bf137d959d5a2e6bc'
  },
  'i.old.xueersi.com': {
    appid: '1000040',
    appkey: '1c27f2e9b78f42eadf12017c936cb766'
  },
  'i.study.xueersi.com': {
    appid: '1001028',
    appkey: '84a953b9f1d4e33db4e290907bb259e2'
  },
  'trade.xueersi.com': {
    appid: '1001029',
    appkey: 'cfe376501a4fca7a4bd7a8f508347ca2'
  },
  'ocenter.xueersi.com': {
    appid: '1001030',
    appkey: '5f93abefab628b8b828b0055056e1a3f'
  },
  'activity.xueersi.com': {
    appid: '1001132',
    appkey: 'e6b7d4993f70f873b89850f5449a3148'
  },
  'code.xueersi.com': {
    appid: '1001108',
    appkey: '23e3e29e862f388f033925b206a997a9'
  },
  'dsp.xueersi.com': {
    appid: '1001327',
    appkey: 'f441afe97c66e51f9fd00a9f6033bab3'
  },
  'expstatic.xueersi.com': {
    appid: '1001385',
    appkey: 'ae89cb1255a426c7accd43bd4231f1e1'
  },
  'home.xueersi.com': {
    appid: '1001399',
    appkey: 'a71cf8e73a7f984f8166b460600b7487'
  },
  'record.xueersi.com': {
    appid: '1001491',
    appkey: '9268d920e266595d416a3e7f2de88da0'
  },
  'scistatic.xueersi.com': {
    appid: '1000033',
    appkey: '256ddeb9e5ebd9cf965ef659934518c2'
  },
  'static.arts.xueersi.com': {
    appid: '1000033',
    appkey: '256ddeb9e5ebd9cf965ef659934518c2'
  },
  'static.chs.xueersi.com': {
    appid: '1000033',
    appkey: '256ddeb9e5ebd9cf965ef659934518c2'
  },
  'synmall.xueersi.com': {
    appid: '1001507',
    appkey: '42e899864aa9f25f83068189fd33137f'
  },
  'bizcrm.xesv5.com': {
    appid: '1001630',
    appkey: '7c7d69f81ea7802fc5164af8207f6225'
  },
  'appeal.xesv5.com': {
    appid: '1001267',
    appkey: '7c777ed04a53972c2208c6d0ba6c1a9b'
  },
  'erp.xesv5.com': {
    appid: '1001554',
    appkey: '7efa582ec24fb1f32ef64bae22377060'
  },
  'express.xesv5.com': {
    appid: '1001553',
    appkey: '4e4d84b77d6d216e794bead389a06ef0'
  },
  'custom.xesv5.com': {
    appid: '1001057',
    appkey: '57639c3d3e84a1be936d8c55bfec369e'
  },
  'admin.xesv5.com': {
    appid: '1001543',
    appkey: 'c5c0d0e788a0025e80236ae79dd73a5a'
  },
  'h5.xesv5.com': {
    appid: '1001564',
    appkey: 'f06adda872621d6964158d494316ff9c'
  },
  'lecture.xueersi.com': {
    appid: '1001568',
    appkey: 'c87d4428bd52bed50c9c115810228abc'
  },
  'adminsci.xesv5.com': {
    appid: '1001581',
    appkey: 'b8062754e1eb41da7d3424e1c7d12bc4'
  },
  'tiku.xesv5.com': {
    appid: '1001590',
    appkey: '9facb6e18f9aa0c270d006e7dc7a51cd'
  },
  'tikuadmin.xesv5.com': {
    appid: '1001591',
    appkey: '47fc0e5f4da2748a3c1a349484cd7747'
  },
  'jylabel.xesv5.com': {
    appid: '1001592',
    appkey: '74d854054ce85d51b9407f2b7dc29cb7'
  },
  'jiaoyan.xesv5.com': {
    appid: '1001593',
    appkey: '116f02ca0392aa70c222fc232e83b873'
  },
  'jyword.xesv5.com': {
    appid: '1001594',
    appkey: '1696aaab2a90b25e6364b76aa6e499e1'
  },
  'courseware.xesv5.com': {
    appid: '1001595',
    appkey: 'd9226a9a0e957fa64da4ed753dcde47c'
  },
  'material.xesv5.com': {
    appid: '1001596',
    appkey: 'f42a1807e93deb693d2ca3fe711e797f'
  },
  'jyworkflow.xesv5.com': {
    appid: '1001597',
    appkey: 'c32091c12ff05dda8bf79d520cf2e151'
  },
  'jydashboard.xesv5.com': {
    appid: '1001598',
    appkey: '740764c10ddecc05ac9a51900e615c05'
  },
  'jybook.xesv5.com': {
    appid: '1001599',
    appkey: '292a39d2c35240874f26ab3135eff360'
  },
  'tnt.xesv5.com': {
    appid: '1001600',
    appkey: '1fa1e4a066543cdd2febd465635a3c99'
  },
  'voice.xesv5.com': {
    appid: '1001601',
    appkey: 'b3464262ea4c42af1e60c4e06ca9716b'
  },
  'help.xesv5.com': {
    appid: '1001602',
    appkey: '66f55e488ec2d650013a49e5f2086d4b'
  },
  'sixuetang.xesv5.com': {
    appid: '1001603',
    appkey: '1501def89d40d3d4bddd61f6524eba5a'
  },
  'ai.xesv5.com': {
    appid: '1001604',
    appkey: '9d2ddaec6fb4a11189caac464b07f251'
  },
  'formula.xesv5.com': {
    appid: '1001605',
    appkey: 'ee86e41d2c6cd9885b81cd7dc09af03e'
  },
  'mcube.xesv5.com': {
    appid: '1001510',
    appkey: '7b9e8e59e91ffcf13ec938dc8d37fda2'
  },
  'wordgroup.xesv5.com': {
    appid: '1001608',
    appkey: '3f9861cd9b990df1be54014c94ecabc3'
  },
  'mockexam.xueersi.com': {
    appid: '1001636',
    appkey: '7d404f5b3f458ec76d046a5d557f3886'
  },
  'res01.xesimg.com': {
    appid: '1001662',
    appkey: 'f4271e8a40a828690bc6e914ecd0e348'
  },
  'res02.xesimg.com': {
    appid: '1001662',
    appkey: 'f4271e8a40a828690bc6e914ecd0e348'
  },
  'res03.xesimg.com': {
    appid: '1001662',
    appkey: 'f4271e8a40a828690bc6e914ecd0e348'
  },
  'res04.xesimg.com': {
    appid: '1001662',
    appkey: 'f4271e8a40a828690bc6e914ecd0e348'
  },
  'res05.xesimg.com': {
    appid: '1001662',
    appkey: 'f4271e8a40a828690bc6e914ecd0e348'
  },
  'res06.xesimg.com': {
    appid: '1001662',
    appkey: 'f4271e8a40a828690bc6e914ecd0e348'
  },
  'res07.xesimg.com': {
    appid: '1001662',
    appkey: 'f4271e8a40a828690bc6e914ecd0e348'
  },
  'res08.xesimg.com': {
    appid: '1001662',
    appkey: 'f4271e8a40a828690bc6e914ecd0e348'
  },
  'res09.xesimg.com': {
    appid: '1001662',
    appkey: 'f4271e8a40a828690bc6e914ecd0e348'
  },
  'res10.xesimg.com': {
    appid: '1001662',
    appkey: 'f4271e8a40a828690bc6e914ecd0e348'
  },
  'res11.xesimg.com': {
    appid: '1001662',
    appkey: 'f4271e8a40a828690bc6e914ecd0e348'
  },
  'res12.xesimg.com': {
    appid: '1001662',
    appkey: 'f4271e8a40a828690bc6e914ecd0e348'
  },
  'res13.xesimg.com': {
    appid: '1001662',
    appkey: 'f4271e8a40a828690bc6e914ecd0e348'
  },
  'res14.xesimg.com': {
    appid: '1001662',
    appkey: 'f4271e8a40a828690bc6e914ecd0e348'
  },
  'res15.xesimg.com': {
    appid: '1001662',
    appkey: 'f4271e8a40a828690bc6e914ecd0e348'
  },
  'res16.xesimg.com': {
    appid: '1001662',
    appkey: 'f4271e8a40a828690bc6e914ecd0e348'
  },
  'res17.xesimg.com': {
    appid: '1001662',
    appkey: 'f4271e8a40a828690bc6e914ecd0e348'
  },
  'res18.xesimg.com': {
    appid: '1001662',
    appkey: 'f4271e8a40a828690bc6e914ecd0e348'
  },
  'live.chs.xueersi.com': {
    appid: '1001667',
    appkey: '2808c0a3a96c721967b274a23324bddf'
  },
  'lyingxiao.xesv5.com': {
    appid: '1001215',
    appkey: 'f04748899a7fb5f135b7bc6e7ecf507c'
  },
  'ad.xesv5.com': {
    appid: '1001227',
    appkey: 'e5fbaf031eacfe08a35f77f3062045fb'
  },
  'pylonadmin.xesv5.com': {
    appid: '1001683',
    appkey: '10d112c809fcb3be71a3ae346f03e5f3'
  }
};
